import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'harting',
} as IModuleProps;
